module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('strong', [_vm._v("B. Constitutional Exemptions After "), _c('em', [_vm._v("Smith")])])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Employment Division v. Smith")]), _vm._v(" hit the religious liberty community like a thunderbolt. Oregon had not asked the Court to take neutral and generally applicable laws out of the protection of the Free Exercise Clause; no one had known that issue was under consideration. The response to "), _c('em', [_vm._v("Smith")]), _vm._v(" was swift and persistent, and it improved over time. The early reactions gave the "), _c('em', [_vm._v("Smith")]), _vm._v(" opinion a worst-case reading, which certainly seemed justified at the time, and may yet turn out to be not far from the Supreme Court’s interpretation. But as time went on, we developed less disastrous alternative readings, which also may turn out to be the Supreme Court’s reading.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This Section includes my early scholarly response to "), _c('em', [_vm._v("Smith")]), _vm._v(" and my early litigation response. It includes one major scholarly article, two short articles, and the briefs and oral argument in the Supreme Court’s only interpretation of "), _c('em', [_vm._v("Smith")]), _vm._v(" through 2010, "), _c('em', [_vm._v("Church of the Lukumi Babalu Aye, Inc. v. City of Hialeah")]), _vm._v(" (1993). The legislative response will appear in Volume 3. It is important to understand that all these responses were going on at the same time. We have printed the three articles in sequence, and then the litigation documents in sequence. But in fact, the sequence was jumbled. The principal scholarly article was written after the first brief in "), _c('em', [_vm._v("Church of the Lukumi")]), _vm._v(", and Congress was holding hearings on the Religious Freedom Restoration Act while the litigation was pending and the scholarly response was emerging.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-12"
    }
  }, [_c('strong', [_vm._v("The Articles …")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("The Amicus Brief That Was Never Filed")]), _vm._v(" is mostly a reprinted amicus brief from the petition for rehearing in "), _c('em', [_vm._v("Smith")]), _vm._v(" itself, written in the first two weeks after the decision.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('em', [_vm._v("Watering Down the Free Exercise Clause")]), _vm._v(" is a short explanation of "), _c('em', [_vm._v("Smith")]), _vm._v(", written for readers who are not lawyers.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("The Remnants of Free Exercise")]), _vm._v(" is a full-scale scholarly treatment of "), _c('em', [_vm._v("Smith")]), _vm._v(" and "), _c('em', [_vm._v("Jimmy Swaggart Ministries v. Board of Equalization")]), _vm._v(", decided three months before "), _c('em', [_vm._v("Smith.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-13"
    }
  }, [_c('strong', [_vm._v("… and the "), _c('em', [_vm._v("Lukumi")]), _vm._v(" Briefs")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The rest of this Section comprises the key briefs in "), _c('em', [_vm._v("Church of the Lukumi Babalu Aye, Inc. v. City of Hialeah")]), _vm._v(" (1993), the first Supreme Court opinion to interpret or explain what "), _c('em', [_vm._v("Smith")]), _vm._v(" means. "), _c('em', [_vm._v("Lukumi")]), _vm._v(" turned out, to the surprise of many, to be a very important case. The Court rejected the worst-case reading of "), _c('em', [_vm._v("Smith")]), _vm._v(" and created a basis for churches and believers to argue that many laws are not neutral and generally applicable. I explain more about the origins and progress of the case, and the issues presented, in the introductions to individual documents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There were eight briefs in all, plus the oral argument, and of course there was a good bit of repetition. The Supreme Court briefs are reprinted in full; the earlier briefs are presented only to the extent that they contain arguments omitted from the Supreme Court briefs.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-14"
    }
  }, [_c('strong', [_vm._v("Cross References")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("These arguments continued to evolve and improve after "), _c('em', [_vm._v("Lukumi.")]), _vm._v(" There is a substantial scholarly treatment in "), _c('em', [_vm._v("Theology Scholarships, the Pledge of Allegiance, and Religious Liberty")]), _vm._v(" (2004) in Volume 1.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is a substantial practical treatment, written for lawyers representing Catholic bishops, in "), _c('em', [_vm._v("The Supreme Court and Religious Liberty")]), _vm._v(" (2000), also in Volume 1.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("There is more treatment of the "), _c('em', [_vm._v("Jimmy Swaggart")]), _vm._v(" case in an amicus brief from that case, and in "), _c('em', [_vm._v("Churches Are Living on Borrowed Time")]), _vm._v(", both in ")]), _c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_vm._v("Section A")]), _vm._v(" of this Part.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There are arguments about how to interpret "), _c('em', [_vm._v("Lukumi")]), _vm._v(" in the briefs in "), _c('em', [_vm._v("In re Young")]), _vm._v(", which will appear in Volume 3.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d7de704","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/014_Chapter02.vue
// module id = 96
// module chunks = 0